import { configWithUserToken } from "../../services/config";
import { IRevenueReport } from "../models/IRevenueReport";

/**
 * Üç kanalın (Online / Phone / DineIn) tahsilatı, ödeme yöntemi ve para birimi kırılımıyla.
 *
 * - `from`/`to` **DateOnly** ("2026-10-01") ve **birlikte** gönderilmeli; tek uç 400 döner.
 * - İkisi de gönderilmezse sunucu **bugünü** uygular.
 * - Pencere en çok 92 takvim günü, `to` günü **dahil**. Gün tanımı Europe/Nicosia.
 */
export const getRevenueReport = (restaurantId: string, from?: string, to?: string) => {
  const p = new URLSearchParams();
  p.append("restourantId", restaurantId);
  // Tek uç göndermek 400 IncompleteDateRange verir — ikisi birden ya da hiçbiri.
  if (from && to) {
    p.append("from", from);
    p.append("to", to);
  }
  return configWithUserToken.get<IRevenueReport>(`RevenueReport?${p.toString()}`);
};
